module.exports = __webpack_public_path__ + "static/home-lg-ff81959ba2c1d6dba0d3d710818a797a.jpg";